import { EFloors, EMaterials } from '../buildersProjects';

export interface IFiltersState {
  appliedFilters: IFilters;
  savedFilters: IFilters;
  meta: IFiltersMeta;
  openedFilter?: TFilterKeys;
  tooltipTarget?: TFilterKeys;
  position?: EPosition;
}

export interface IFilters {
  priceFrom?: number;
  priceTo?: number;
  areaFrom?: number;
  areaTo?: number;
  floors?: EFloors[];
  materials?: EMaterials[];
}

export enum EFiltersMetaStatus {
  Initial = 'initial',
  Pending = 'pending',
  Success = 'success',
  Fail = 'fail',
}

export interface IFiltersMeta {
  data?: IFiltersMetaResponse;
  status: EFiltersMetaStatus;
}

export interface IFiltersMetaResponse {
  count: number;
}

export type TFilterKeys = 'price' | 'area' | 'floors' | 'materials';

export enum EPosition {
  Static = 'static',
  Fixed = 'fixed-in',
  FixedHidden = 'fixed-out',
}
